"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainView = exports.query = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var month_selector_1 = require("./components/month-selector");
var calendar_view_1 = require("../calendar/calendar-view");
var Actions = __importStar(require("./main-actions"));
var calendar_id_1 = require("./calendar-id");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var use_graphql_query_1 = require("../graphql/use-graphql-query");
var CalendarSelectButtons = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n\n  @media (max-width: 600px) {\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n\n  @media (max-width: 600px) {\n    justify-content: center;\n  }\n"])));
var CalendarSelectButton = styled_components_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  padding: 3px 18px;\n  border-right: 1px solid ", ";\n  &:hover {\n    text-decoration: underline;\n    cursor: pointer;\n    color: ", ";\n  }\n  &:first-child {\n    border-left: 1px solid ", ";\n  }\n  ", "\n"], ["\n  color: ", ";\n  padding: 3px 18px;\n  border-right: 1px solid ", ";\n  &:hover {\n    text-decoration: underline;\n    cursor: pointer;\n    color: ", ";\n  }\n  &:first-child {\n    border-left: 1px solid ", ";\n  }\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.coloredText;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.divid;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.textHighlight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.divid;
}, function (props) {
    return props.selected &&
        "& {\n      background-color: ".concat(props.theme.colors.divid, ";\n      color: ").concat(props.theme.colors.bodyInverted, ";\n    }\n");
});
exports.query = (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  query MainView_Calendars {\n    calendars {\n      id\n      calendarName\n    }\n  }\n"], ["\n  query MainView_Calendars {\n    calendars {\n      id\n      calendarName\n    }\n  }\n"])));
function MainView(_a) {
    var state = _a.state, dispatch = _a.dispatch;
    var selectedYear = state.selectedYear, selectedMonth = state.selectedMonth, selectedCalendar = state.selectedCalendar;
    var loadedQuery = (0, use_graphql_query_1.useGraphqlQuery)(exports.query).loadedQuery;
    if (!loadedQuery) {
        return React.createElement("div", null, "LOADING...");
    }
    return (React.createElement("div", null,
        React.createElement(CalendarSelectButtons, null, loadedQuery.response.data.calendars.map(function (calendar) {
            var calendarId = (0, calendar_id_1.getCalendarIdByNumber)(calendar.id);
            return (React.createElement(CalendarSelectButton, { key: calendar.id, onClick: function () { return dispatch(Actions.setSelectedCalendar(calendarId)); }, selected: selectedCalendar === calendarId, tabIndex: 0 }, (0, calendar_id_1.getCalendarDisplayName)(calendarId)));
        })),
        React.createElement("div", null,
            React.createElement(month_selector_1.MonthSelector, { year: selectedYear, month: selectedMonth, onChange: function (year, month) { return dispatch(Actions.setMonth(year, month)); } })),
        React.createElement(calendar_view_1.CalendarView, { state: state.calendarState, dispatch: function (a) { return dispatch(Actions.dispatchCalendar(a)); }, calendarId: selectedCalendar, year: selectedYear, month: selectedMonth })));
}
exports.MainView = MainView;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=main-view.js.map